export function randomChoice(array) {
  return array[Math.floor(Math.random() * array.length)];
}
